module.exports = __webpack_public_path__ + "static/work15-897090b3a5bef46b504f160ae405a85d.jpg";